export const optionsReturnPublished = [
  {
    id: '1',
    label: 'Sin Postor',
    value: 'Sin Postor'
  },
];

export const optionsReturnInvoiced = [
  {
    id: '1',
    label: 'No Pagado',
    value: 'No Pagado'
  },
  {
    id: '2',
    label: 'No Retirado',
    value: 'No Retirado'
  }
];
